import React from 'react';
import { Grid } from '@material-ui/core';
import Table from '../../components/Table';
import { ContactUsService } from '../../service/ContactUsService';

const tableHead = [
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'motive.name',
    label: 'Motivo',
  },
  {
    id: 'email',
    label: 'Email',
  },
  {
    id: 'phone',
    label: 'Telefone',
  },
  {
    id: 'message',
    label: 'Mensagem',
  },
  {
    id: 'created_at',
    label: 'Data de Inscrição',
  },
];

class ContactUsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
    };
    this.getList();
  }

  async getList() {
    try {
      const res = await ContactUsService.list();
      console.log(res.data);

      res.data.map(item => {
        item.created_at = new Date(item.created_at).toLocaleDateString('pt-BR');
        return item;
      });

      this.setState({
        data: res.data,
        loading: false,
      });
    } catch (e) {}
  }
  render() {
    return (
      <Grid container spacing={24}>
        {/* <Grid item xs={12}>
          <Typography>
            Filtrar por data: <TextField id="date" type="date" />a
            <TextField id="date" type="date" />
          </Typography>
        </Grid> */}
        <Grid item xs={12}>
          <Table
            title="Contatos"
            head={tableHead}
            loading={this.state.loading}
            data={this.state.data}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Typography>
            <Button size="small" color="primary">
              <CloudDownloadIcon style={{ marginRight: 5 }} />
              Download
            </Button>
            {this.state.data.length} usuários
          </Typography>
        </Grid> */}
      </Grid>
    );
  }
}

export { ContactUsList };
